import { useMemo } from 'react'
import { append, join } from 'ramda'
import { useQuery } from '@tanstack/react-query'
import { useToast } from '@machobear/design-system'
import { addAddOn, addAddOnWithCoupon } from '@/models/plans/apis'
export const getDryRun = async ({
  items,
  metadata,
  couponCode,
  country_code,
  state
}: {
  items: any
  metadata?: any
  couponCode?: string | null | undefined
  country_code: string
  state: string
}) => {
  try {
    if (!!couponCode) {
      const response = await addAddOnWithCoupon(
        {
          country_code,
          state,
          items,
          couponCode,
          metadata
        },
        { couponCode }
      )

      return response
    } else {
      const response = await addAddOn({
        country_code,
        state,
        items,
        metadata
      })
      return response
    }
  } catch (error) {
    throw error
  }
}

const getFormattedCountry = (country: string = '') => {
  return country?.toUpperCase()
}

const getQueryKeyWithItems = (queryKey: (string | null | undefined)[], items: any) => {
  const itemPriceIds = items?.map((item: any) => item?.priceId)
  const updateQueryKey = append(queryKey, itemPriceIds)

  return join('-', updateQueryKey)
}

const useDryRun = ({
  items,
  metadata,
  coupon,
  country,
  state
}: {
  items: any
  metadata?: any
  coupon?: string | null | undefined
  country: string
  state: string
}) => {
  const formattedCountry = useMemo(() => getFormattedCountry(country), [country])
  const formattedState = state || 'BC'
  const showToast = useToast()

  const response = useQuery({
    queryKey: ['dryRun', country, state, coupon],
    queryFn: async () => {
      const response = await getDryRun({
        items: items,
        metadata: metadata,
        couponCode: coupon,
        state: formattedState,
        country_code: formattedCountry
      })

      if (!response?.response?.ok) {
        showToast({
          message: response?.body?.message,
          tone: 'critical'
        })
        throw new Error(response?.body)
      }

      return response?.body
    },
    queryKeyHashFn: queryKey => getQueryKeyWithItems(queryKey, items),
    retry: false,
    refetchOnMount: false,
    staleTime: 5 * 60000
  })
  return response
}
export default useDryRun
